module.exports = __webpack_public_path__ + "building.c88e14beebe2ffe2eeb9436feadbfcb5.svg";